import React from "react";
import { Table, Badge, Button, Spinner, Alert } from "react-bootstrap";
import { IoEye, IoCreate, IoTrash } from "react-icons/io5";
import { FaSort, FaSortUp, FaSortDown } from "react-icons/fa";

const CustomerTable = ({
  user = [],
  loading = false,
  error = null,
  pagination = {},
  meta = {},
  currentSortField = null,
  currentSortOrder = "DESC",
  onSort = () => {},
  onEdit = () => {},
  onDelete = () => {},
  onView = () => {},
}) => {
  
  const formatDate = (dateString) => {
    if (!dateString) return "-";
    const date = new Date(dateString);
    return date.toLocaleDateString("id-ID", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  // Render badge untuk status
  const getStatusBadge = (status) => {
    const statusConfig = {
      DRAFT: { variant: "warning", label: "Draft" },
      PUBLISHED: { variant: "success", label: "Published" },
      ARCHIVED: { variant: "secondary", label: "Archived" },
    };
    const config = statusConfig[status] || { variant: "light", label: status };
    return <Badge bg={config.variant}>{config.label}</Badge>;
  };

  // Render badge untuk type
  const getRoleBadge = (role) => {
    const roleConfig = {
      ADMIN: { variant: "info", label: "Administrator" },
      USER: { variant: "secondary", label: "User" },
      DOCTOR: { variant: "danger", label: "Doctor" },
    };
    const config = roleConfig[role] || { variant: "light", label: role };
    return <Badge bg={config.variant}>{config.label}</Badge>;
  };

  // Render icon sort
  const renderSortIcon = (field) => {
    if (currentSortField !== field) return <FaSort className="text-muted" />;
    return currentSortOrder === "ASC" ? <FaSortUp /> : <FaSortDown />;
  };

  // Loading state
  if (loading) {
    return (
      <div className="text-center py-5">
        <Spinner animation="border" variant="primary" />
        <p className="mt-2">Loading user...</p>
      </div>
    );
  }

  // Error state
  if (error) {
    return (
      <Alert variant="danger" className="my-4">
        <Alert.Heading>Error Loading Data</Alert.Heading>
        <p>{error}</p>
      </Alert>
    );
  }

  // Empty state
  if (!loading && !error && user.length === 0) {
    return (
      <div className="text-center py-5 border rounded">
        <p className="text-muted mb-2">No user found</p>
        {pagination.search && (
          <small className="text-muted">
            Try adjusting your search or filter
          </small>
        )}
      </div>
    );
  }

  return (
    <div className="table-responsive">
      <Table hover striped>
        <thead>
          <tr>
            <th style={{ width: "auto" }}>No.</th>
            <th style={{ width: "15%" }}>
              <Button
                variant="link"
                className="p-0 text-decoration-none text-dark fw-semibold"
                onClick={() => onSort("deleted_at")}
              >
                Status {renderSortIcon("deleted_at")}
              </Button>
            </th>
            <th style={{ width: "auto" }}>
              <Button
                variant="link"
                className="p-0 text-decoration-none text-dark fw-semibold"
                onClick={() => onSort("username")}
              >
                Username {renderSortIcon("username")}
              </Button>
            </th>
            <th style={{ width: "auto" }}>
              <Button
                variant="link"
                className="p-0 text-decoration-none text-dark fw-semibold"
                onClick={() => onSort("email")}
              >
                Email {renderSortIcon("email")}
              </Button>
            </th>
            <th style={{ width: "auto" }}>
              <Button
                variant="link"
                className="p-0 text-decoration-none text-dark fw-semibold"
                onClick={() => onSort("role")}
              >
                Role {renderSortIcon("role")}
              </Button>
            </th>
            <th style={{ width: "auto" }}>
              <Button
                variant="link"
                className="p-0 text-decoration-none text-dark fw-semibold"
                onClick={() => onSort("created_at")}
              >
                Created {renderSortIcon("created_at")}
              </Button>
            </th>
            <th style={{ width: "auto" }} className="text-center">
              <span className="fw-semibold">Actions</span>
            </th>
          </tr>
        </thead>
        <tbody>
          {user.map(
            (
              item,
              index, // Tambahkan index sebagai parameter kedua
            ) => (
              <tr key={item.id}>
                <td>
                  {/* Nomor urut */}
                  {index + 1}
                </td>
                <td>
                  {item.deleted_at ? (
                    <Badge bg="danger">Deleted</Badge>
                  ) : (
                    <Badge bg="success">Active</Badge>
                  )}
                </td>
                <td>
                  <div className="d-flex flex-column">
                    <strong className="mb-1">{item.username}</strong>
                    {item.full_name && (
                      <small className="text-muted">
                        {item.full_name.substring(0, 100)}
                        {item.full_name.length > 100 && "..."}
                      </small>
                    )}
                  </div>
                </td>
                <td>{item.email}</td>
                <td>{getRoleBadge(item.role)}</td>
                <td>
                  <small className="text-muted">
                    {formatDate(item.created_at)}
                  </small>
                </td>
                <td>
                  <div className="d-flex justify-content-center gap-2">
                    <Button
                      variant="outline-danger"
                      size="sm"
                      title="Delete Artikel"
                      onClick={() => onDelete(item.id)}
                    >
                      <IoTrash />
                    </Button>
                  </div>
                </td>
              </tr>
            ),
          )}
        </tbody>
      </Table>
    </div>
  );
};

export default CustomerTable;
